import React from 'react'
import styled from 'styled-components'

import { theme } from '../../../../theme'
import { Spinner, ToggleDecoupled } from '../../../uikit'

const ApprovalSection = styled.div`
  background-color: ${theme.colors.lightBg};
  border-radius: 8px;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
`

const ApprovalLabel = styled.div`
  font-weight: ${theme.fontWeight.medium};
  font-size: 16px;
  color: ${theme.colors.primaryDefault};
`

type ApprovalToggleProps = {
  isApproved: boolean
  isLoading?: boolean
  disabled?: boolean
  onApprovalToggle: () => void
}

export const ApprovalToggle = ({
  isApproved,
  isLoading,
  disabled: areControlsDisabled,
  onApprovalToggle,
}: ApprovalToggleProps) => (
  <ApprovalSection>
    <ApprovalLabel>Approved</ApprovalLabel>
    {isLoading ? (
      <Spinner size={30} color={theme.colors.altovita} />
    ) : (
      <ToggleDecoupled
        isChecked={isApproved}
        isDisabled={areControlsDisabled}
        onClick={onApprovalToggle}
      />
    )}
  </ApprovalSection>
)
